/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_ID_73_68 as Componente_ID_73_68,
  rec_Gi as Gi,
  rec_JSXRuntime as JSXRuntime,
  rec_Mi as Mi,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Xx as Xx,
  rec_Yx as Yx,
  rec_Zx as Zx,
  rec_ei as ei,
  rec_fS as fS,
  rec_ki as ki,
  rec_oi as oi,
} from "../../runtime/index.jsx";
export function TarjetaKanban(e) {
  let t = (0, ReactCompiler.c)(39),
    { t: n, arrastrando: r, cerrada: i } = e,
    a = `flex flex-col gap-1.5 rounded-xl border border-(--border) bg-(--bg) p-2.5 ${r ? `shadow-2xl` : ``} ${i ? `opacity-80` : ``}`,
    o;
  t[0] === i
    ? (o = t[1])
    : ((o =
        i &&
        (0, JSXRuntime.jsx)(oi, {
          className: `h-3 w-3 shrink-0 text-(--text)`,
        })),
      (t[0] = i),
      (t[1] = o));
  let s;
  t[2] !== n.titulo || t[3] !== o
    ? ((s = (
        <span
          className={`flex items-center gap-1 text-sm text-(--text-h)`}
          children={[o, n.titulo]}
        />
      )),
      (t[2] = n.titulo),
      (t[3] = o),
      (t[4] = s))
    : (s = t[4]);
  let c;
  t[5] === n.etiquetas
    ? (c = t[6])
    : ((c = n.etiquetas?.length > 0 && (
        <span
          className={`flex flex-wrap gap-1`}
          children={n.etiquetas.map(Componente_ID_73_68)}
        />
      )),
      (t[5] = n.etiquetas),
      (t[6] = c));
  let l;
  t[7] === n.prioridad
    ? (l = t[8])
    : ((l = Zx(n.prioridad)), (t[7] = n.prioridad), (t[8] = l));
  let u = `rounded-full px-1.5 py-0.5 text-[10px] ${l}`,
    d;
  t[9] === n.prioridad
    ? (d = t[10])
    : ((d = Yx(n.prioridad)), (t[9] = n.prioridad), (t[10] = d));
  let f;
  t[11] !== u || t[12] !== d
    ? ((f = <span className={u} children={d} />),
      (t[11] = u),
      (t[12] = d),
      (t[13] = f))
    : (f = t[13]);
  let p;
  t[14] !== n.atrasada || t[15] !== n.fechaVencimiento
    ? ((p = n.fechaVencimiento && (
        <span
          className={`text-[11px] ${n.atrasada ? `font-medium text-(--error)` : `text-(--text)`}`}
          children={fS(n.fechaVencimiento)}
        />
      )),
      (t[14] = n.atrasada),
      (t[15] = n.fechaVencimiento),
      (t[16] = p))
    : (p = t[16]);
  let m;
  t[17] !== n.checklistHechos || t[18] !== n.checklistTotal
    ? ((m = n.checklistTotal > 0 && (
        <span
          className={`inline-flex items-center gap-0.5 text-[11px] tabular-nums text-(--text)`}
          children={[
            (0, JSXRuntime.jsx)(ei, {
              className: `h-3 w-3`,
            }),
            n.checklistHechos,
            `/`,
            n.checklistTotal,
          ]}
        />
      )),
      (t[17] = n.checklistHechos),
      (t[18] = n.checklistTotal),
      (t[19] = m))
    : (m = t[19]);
  let h;
  t[20] === n.recurrencia
    ? (h = t[21])
    : ((h =
        n.recurrencia &&
        n.recurrencia !== `NINGUNA` &&
        (0, JSXRuntime.jsx)(ki, {
          className: `h-3 w-3 text-(--text)`,
          "aria-label": `Se repite`,
        })),
      (t[20] = n.recurrencia),
      (t[21] = h));
  let _;
  t[22] === n
    ? (_ = t[23])
    : ((_ = Xx(n) && (
        <span className={`text-[11px] text-(--text)`} children={Xx(n)} />
      )),
      (t[22] = n),
      (t[23] = _));
  let v;
  t[24] !== m || t[25] !== h || t[26] !== _ || t[27] !== f || t[28] !== p
    ? ((v = (
        <span
          className={`flex flex-wrap items-center gap-1.5`}
          children={[f, p, m, h, _]}
        />
      )),
      (t[24] = m),
      (t[25] = h),
      (t[26] = _),
      (t[27] = f),
      (t[28] = p),
      (t[29] = v))
    : (v = t[29]);
  let y;
  t[30] !== n.listaNombre || t[31] !== n.metaTitulo
    ? ((y = (n.metaTitulo || n.listaNombre) && (
        <span
          className={`flex flex-wrap gap-2 text-[10px]`}
          children={[
            n.metaTitulo && (
              <span
                className={`inline-flex items-center gap-1 text-(--accent)`}
                children={[<Gi className={`h-3 w-3`} />, n.metaTitulo]}
              />
            ),
            n.listaNombre && (
              <span
                className={`inline-flex items-center gap-1 text-(--text)`}
                children={[<Mi className={`h-3 w-3`} />, n.listaNombre]}
              />
            ),
          ]}
        />
      )),
      (t[30] = n.listaNombre),
      (t[31] = n.metaTitulo),
      (t[32] = y))
    : (y = t[32]);
  let b;
  return (
    t[33] !== a || t[34] !== v || t[35] !== y || t[36] !== s || t[37] !== c
      ? ((b = <div className={a} children={[s, c, v, y]} />),
        (t[33] = a),
        (t[34] = v),
        (t[35] = y),
        (t[36] = s),
        (t[37] = c),
        (t[38] = b))
      : (b = t[38]),
    b
  );
}
